export const ExportEventType = {
    EXPORT_FAILED: "EXPORT_FAILED",
    EXPORT_DELIVERY: "EXPORT_DELIVERY",
    EXPORT_PROGRESS: "EXPORT_PROGRESS",
};
